// node modules
import React from 'react';
import { SearchkitComponent, SortingSelector, SortingAccessor } from 'searchkit';
import withStyles from 'isomorphic-style-loader/withStyles';
import Tooltip from 'rc-tooltip';

// app modules: components
import Button from 'components/Button';
import Icon from 'components/Icon';
import SearchkitMenu from 'components/SearchkitMenu';

// constants
import { COLOURS } from 'constants/index';
import { SORT_OPTIONS } from 'constants/search';

// assets
import CssSearchSortOptions from './SearchSortOptions.scss';

class SearchSortOptions extends SearchkitComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedSortOption: null,
      visible: false,
    };

    this.bound = {
      handleButtonClick: this.handleButtonClick.bind(this),
    };
  }

  componentDidMount() {
    super.componentDidMount();
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      visible: false,
      selectedSortOption: this.accessor.getSelectedOption(),
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { visible } = this.state;
    const currentSortOption = this.accessor.getSelectedOption();
    const prevSortOption = prevState.selectedSortOption;

    if (visible && this.accessor && currentSortOption.key !== prevSortOption.key) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        visible: false,
        selectedSortOption: currentSortOption,
      });
    }
  }

  componentWillUnmount() {
    if (this.accessor) {
      const currentOption = this.accessor.getSelectedOption();
      if (currentOption.key === 'book') {
        this.accessor.resetState();
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  defineAccessor() {
    return new SortingAccessor('sort', { options: SORT_OPTIONS });
  }

  handleButtonClick() {
    const { visible } = this.state;
    this.setState({ visible: !visible });
  }

  render() {
    const { visible } = this.state;
    if (!this.accessor) {
      return null;
    }
    const currentOption = this.accessor.getSelectedOption();

    return (
      <div className="search-sort-options">
        <div className="search-sort-options__label">Sort by:</div>
        <Tooltip
          defaultVisible={false}
          visible={visible}
          overlay={<SortingSelector listComponent={SearchkitMenu} options={SORT_OPTIONS} />}
          mouseEnterDelay={0.75}
          placement="bottom"
          overlayClassName="rc-tooltip--plain"
          getTooltipContainer={() => document.querySelector('.search-sort-options')}
        >
          <Button
            themeType="clear"
            themeName="energized"
            size="large"
            title={currentOption.label}
            onClick={this.bound.handleButtonClick}
          >
            {currentOption.label}{' '}
            <Icon
              fill={COLOURS.ENERGIZED}
              name={visible ? 'caret' : 'caret-down'}
              height="14"
              width="14"
              mr={5}
            />
          </Button>
        </Tooltip>
      </div>
    );
  }
}

export default withStyles(CssSearchSortOptions)(SearchSortOptions);
